// extracted by mini-css-extract-plugin
module.exports = {"input":"InputRange__input__vKGmK"};